import React from 'react';

// Redux
import { Provider } from 'react-redux';
import { store } from './redux/store';

import { RouterConfig } from './navigation/RouterConfig';
import { userAbility } from './components/CASL/abilities';
import AbilityContext from './components/CASL/AbilityContext';

import IdleLogout from './components/IdleLogout';
import { IdleLogoutProvider } from './context/IdleLogoutContext';
import { GlobalNotificationProvider } from '@components/GlobalNotificationProvider';

import './styles/bootstrap.min.css';
import './styles/style.css';
import './styles/loader.css';
import './styles/common.css';

const App = () => (
    <div>
        <AbilityContext.Provider value={userAbility}>
            <Provider store={store}>
                <GlobalNotificationProvider>
                    <IdleLogoutProvider>
                        <IdleLogout />
                        <RouterConfig />
                    </IdleLogoutProvider>
                </GlobalNotificationProvider>
            </Provider>
        </AbilityContext.Provider>
    </div>
);

export default App;